import "./IdentificationForm.scss";

import React, { useMemo } from "react";
import { useBemBlock } from "../../../../common/utils/bemContext/bemContextHook";
import { cl } from "@ngd-web/lv-utils/ui/classNames";
import PhoneIconComponent from "../../../../common/icons/PhoneIconComponent";
import { useDispatch } from "react-redux";
import { identifyUserOnSubscriptionPreferencesAction } from "../subscriptionPreferences/subscriptionPreferencesActions";
import { SubscriptionPreferencesFormInputGroupComponent } from "../_shared/formInputGroup/SubscriptionPreferencesFormInputGroupComponent";
import { SubscriptionPreferencesFormButtonComponent } from "../_shared/formButton/SubscriptionPreferencesFormButtonComponent";

const i18n = {
    phone: "Phone number",
    getCode: "Get code",
};

export function IdentificationFormComponent({ className }) {
    const [bl, el] = useBemBlock("usmIdentificationForm");

    const dispatch = useDispatch();
    const [identify] = useMemo(
        () => [
            () => {
                dispatch(identifyUserOnSubscriptionPreferencesAction("+xxx"));
            },
        ],
        []
    );

    return (
        <div className={cl(className, bl())}>
            <SubscriptionPreferencesFormInputGroupComponent
                inputHolderClassName={el("input")}
                label={i18n.phone}
                IconElement={PhoneIconComponent}
            />

            <SubscriptionPreferencesFormButtonComponent
                className={el("button")}
                onClick={identify}
                title={i18n.getCode}
            />
        </div>
    );
}
